export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificaciones"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista de certificaciones vencidas o por vencer"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver todas"])},
          "provider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor"])},
          "certification": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificación"])},
          "expiration_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de expiración"])},
          "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
          "days": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["días"])},
          "expired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencida"])}
        }
      }
    }
  })
}